import { T, useT } from '@transifex/react';
import React from 'react';
import { VendImage } from '../vendImage/VendImage';
import { withTranslations } from '../../tx';
const NotFoundPageUnconnected = () => {
    const t = useT();
    return (React.createElement("section", { "data-testid": "NotFoundPage", className: "vd-error-main vd-align-center", style: { marginTop: '100px' } },
        React.createElement("div", { className: "vd-flex vd-flex--column vd-flex--align-center vd-pt10" },
            React.createElement(VendImage, { relativeImagePath: "error/something-went-wrong-v3.svg", alt: t('Something went wrong', { _context: 'NotFoundPage' }) }),
            React.createElement("section", { className: "vd-section" },
                React.createElement("div", { className: "vd-section-wrap" },
                    React.createElement("h1", { className: "vd-header vd-header--section" },
                        React.createElement(T, { _str: "We can\u2019t find the page you\u2019re looking for." })),
                    React.createElement("p", { className: "vd-text--sub" },
                        React.createElement(T, { _str: "This page is no longer available, or an invalid URL has been entered." })))))));
};
export const NotFoundPage = withTranslations(NotFoundPageUnconnected, 'NotFoundPage');
